import i18n from '@/plugins/i18n';
import { headerKeyType, InstanceType } from '@/components/K8M/k8.types';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';

const K8HeaderKeys = Object.freeze({
  namespace: 'namespace',
  nmTitle: 'K8S_NAMESPACE',
  podNm: 'metaProperty1',
  nodeNm: 'metaProperty1',
  workloadNm: 'metaProperty1',
  nodeIp: 'metaProperty3',
  nmTotalPods: 'K8S_POD',
  nmTotalDeps: 'K8S_DEPLOYMENT',
  nmTotalSer: 'k8s_namespace_v2_service_total',
  nmTotalDaemon: 'K8S_DAEMON_SET',
  nmTotalStats: 'K8S_STATEFULSET',
  nmStatus: 'k8s_namespace_v2_namespace_status',
  depTotalPods: 'k8s_deployment_v2_pods_total',
  depAvailPods: 'k8s_deployment_v2_pods_available',
  depMissPods: 'k8s_deployment_v2_pods_unavailable',
  depStatus: 'k8s_deployment_v2_status',
  daemonTotalPods: 'k8s_daemonset_v2_pods_total',
  daemonAvailPods: 'k8s_daemonset_v2_pods_available',
  daemonMissPods: 'k8s_daemonset_v2_pods_unavailable',
  statTotalPods: 'k8s_statefulset_v2_pods_total',
  statAvailPods: 'k8s_statefulset_v2_pods_available',
  statMissPods: 'k8s_statefulset_v2_pods_unavailable',
  status: 'status',
  podStatus: 'k8s_pods_v2_status',
  nodeStatus: 'k8s_node_v2_status',
  node: 'nodes',
  nodeCPUusage: 'k8s_node_v2_cpu_usage',
  podCPUusage: 'k8s_pods_v2_cpu_cores_usage',
  nodeMemUsage: 'k8s_node_v2_memory_usage',
  podMemUsage: 'k8s_pods_v2_memory_usage_bytes',
  nodeStorage: 'k8s_node_v2_fs_usage',
  deployment: 'deployments',
  statefulset: 'statefulsets',
  daemonset: 'daemonsets',
  podName: 'pods',
  ipAddr: 'metaProperty3',
  availPods: 'availablePods',
  missPods: 'missingPods',
});

const headerKeys = {
  node: () => [
    {
      key: K8HeaderKeys.node,
      name: i18n.global.t('k8.node'),
      width: '35%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.nodeIp,
      name: i18n.global.t('k8.ipAddr'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.META_PROPERTY,
    },
    {
      key: K8HeaderKeys.nodeCPUusage,
      name: i18n.global.t('k8.CPUusage'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nodeMemUsage,
      name: i18n.global.t('k8.memoryUsage'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nodeStorage,
      name: i18n.global.t('k8.storage'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nodeStatus,
      name: i18n.global.t('k8.status'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.LABELED_METRICS,
    },
  ],
  namespace: () => [
    {
      key: K8HeaderKeys.nmTitle,
      name: i18n.global.t('k8.namespace'),
      width: '23%',
      sortable: false,
      routable: false,
    },
    {
      key: K8HeaderKeys.nmTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nmTotalSer,
      name: i18n.global.t('k8.clusterServiceTotal'),
      width: '12%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nmTotalDeps,
      name: i18n.global.t('k8.clusterDeploymentTotal'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nmTotalStats,
      name: i18n.global.t('k8.clusterStatefulsets'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nmTotalDaemon,
      name: i18n.global.t('k8.clusterDaemonsets'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.nmStatus,
      name: i18n.global.t('k8.status'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.LABELED_METRICS,
    },
  ],
  deployment: () => [
    {
      key: K8HeaderKeys.deployment,
      name: i18n.global.t('k8.deployment'),
      width: '30%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.workloadNm,
      name: i18n.global.t('k8.namespace'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.META_PROPERTY,
    },
    {
      key: K8HeaderKeys.depTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depStatus,
      name: i18n.global.t('k8.status'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.LABELED_METRICS,
    },
  ],
  statefulset: () => [
    {
      key: K8HeaderKeys.statefulset,
      name: i18n.global.t('k8.statefulset'),
      width: '45%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.workloadNm,
      name: i18n.global.t('k8.namespace'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.META_PROPERTY,
    },
    {
      key: K8HeaderKeys.statTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.statAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.statMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
  ],
  daemonset: () => [
    {
      key: K8HeaderKeys.daemonset,
      name: i18n.global.t('k8.daemonset'),
      width: '40%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.workloadNm,
      name: i18n.global.t('k8.namespace'),
      width: '20%',
      sortable: false,
      routable: false,
      type: headerKeyType.META_PROPERTY,
    },
    {
      key: K8HeaderKeys.daemonTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.daemonAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.daemonMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
  ],
  pod: () => [
    {
      key: K8HeaderKeys.podName,
      name: i18n.global.t('k8.podName'),
      width: '35%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.podNm,
      name: i18n.global.t('k8.namespace'),
      width: '20%',
      sortable: false,
      routable: false,
      type: headerKeyType.META_PROPERTY,
    },
    {
      key: K8HeaderKeys.podCPUusage,
      name: i18n.global.t('k8.cpuCores'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
      displayUnit: true,
      unit: 'm',
    },
    {
      key: K8HeaderKeys.podMemUsage,
      name: i18n.global.t('k8.memUsage'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
      formatBytes: true,
      aggregation: '/',
      aggregationNum: '1048576',
      unit: 'MB',
    },
    {
      key: K8HeaderKeys.podStatus,
      name: i18n.global.t('k8.status'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.LABELED_METRICS,
    },
  ],
};

const OverviewHeaderKeys = {
  deployment: () => [
    {
      key: K8HeaderKeys.deployment,
      name: i18n.global.t('k8.deployment'),
      width: '50%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.depTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '10%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.depStatus,
      name: i18n.global.t('k8.status'),
      width: '15%',
      sortable: false,
      routable: false,
      type: headerKeyType.LABELED_METRICS,
    },
  ],
  statefulset: () => [
    {
      key: K8HeaderKeys.statefulset,
      name: i18n.global.t('k8.statefulset'),
      width: '55%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.statTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.statAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.statMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
  ],
  daemonset: () => [
    {
      key: K8HeaderKeys.daemonset,
      name: i18n.global.t('k8.daemonset'),
      width: '55%',
      sortable: false,
      routable: true,
    },
    {
      key: K8HeaderKeys.daemonTotalPods,
      name: i18n.global.t('k8.clusterPodTotal'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.daemonAvailPods,
      name: i18n.global.t('k8.availablePods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
    {
      key: K8HeaderKeys.daemonMissPods,
      name: i18n.global.t('k8.missingPods'),
      width: '15%',
      sortable: true,
      routable: false,
      type: headerKeyType.METRIC,
    },
  ],
};

const K8NodeOverviewConfig = () => ({
  title: i18n.global.t('k8.node'),
  routeName: 'nodes',
  headerKeys: headerKeys['node'](),
  disableTitle: true,
  instanceType: InstanceType['nodes'],
  showSearch: true,
  searchPlaceholder: i18n.global.t('k8.nodePlace'),
  defaultSortKey: K8HeaderKeys.nodeCPUusage,
});

const K8ClusterTablesConfig = () => [
  {
    title: i18n.global.t('k8.namespace'),
    routeName: 'namespaces',
    disableTitle: false,
    headerKeys: headerKeys['namespace'](),
    instanceType: InstanceType['namespaces'],
    tab: K8_NAVTABS.K8M_NAMESPACE_TAB,
    defaultSortKey: K8HeaderKeys.nmTotalPods,
  },
  {
    title: i18n.global.t('k8.deployment'),
    routeName: 'deployments',
    disableTitle: false,
    headerKeys: headerKeys['deployment'](),
    instanceType: InstanceType['deployments'],
    tab: K8_NAVTABS.K8M_DEP_TAB,
    defaultSortKey: K8HeaderKeys.depTotalPods,
  },
  {
    title: i18n.global.t('k8.statefulset'),
    routeName: 'statefulsets',
    disableTitle: false,
    headerKeys: headerKeys['statefulset'](),
    instanceType: InstanceType['statefulsets'],
    tab: K8_NAVTABS.K8M_STAT_TAB,
    defaultSortKey: K8HeaderKeys.statTotalPods,
  },
  {
    title: i18n.global.t('k8.daemonset'),
    routeName: 'daemonsets',
    disableTitle: false,
    headerKeys: headerKeys['daemonset'](),
    instanceType: InstanceType['daemonsets'],
    tab: K8_NAVTABS.K8M_DAEMON_TAB,
    defaultSortKey: K8HeaderKeys.daemonTotalPods,
  },
  {
    title: i18n.global.t('k8.pod'),
    routeName: 'pods',
    disableTitle: false,
    headerKeys: headerKeys['pod'](),
    instanceType: InstanceType['pods'],
    tab: K8_NAVTABS.K8M_POD_TAB,
    defaultSortKey: K8HeaderKeys.podCPUusage,
  },
];

const K8NamespaceConfig = () => [
  {
    title: i18n.global.t('k8.namespace'),
    routeName: 'namespaces',
    disableTitle: false,
    disableViewBtn: true,
    displayTotal: true,
    titleWithCount: i18n.global.t('k8.namespace'),
    headerKeys: headerKeys['namespace'](),
    instanceType: InstanceType['namespaces'],
    searchPlaceholder: i18n.global.t('k8.nmPlace'),
    showSearch: true,
    defaultSortKey: K8HeaderKeys.nmTotalPods,
  },
];
const K8DeploymentConfig = () => [
  {
    title: i18n.global.t('k8.deployment'),
    titleWithCount: i18n.global.t('k8.allDeployments'),
    routeName: 'deployments',
    showSearch: true,
    disableViewBtn: true,
    searchPlaceholder: i18n.global.t('k8.deploymentPlace'),
    displayTotal: true,
    disableTitle: false,
    headerKeys: OverviewHeaderKeys['deployment'](),
    instanceType: InstanceType['deployments'],
    defaultSortKey: K8HeaderKeys.depTotalPods,
  },
];

const K8StatefulsetConfig = () => [
  {
    title: i18n.global.t('k8.statefulset'),
    titleWithCount: i18n.global.t('k8.allStatefulsets'),
    routeName: 'statefulsets',
    showSearch: true,
    displayTotal: true,
    disableTitle: false,
    disableViewBtn: true,
    searchPlaceholder: i18n.global.t('k8.statefulsetPlace'),
    headerKeys: OverviewHeaderKeys['statefulset'](),
    instanceType: InstanceType['statefulsets'],
    defaultSortKey: K8HeaderKeys.statTotalPods,
  },
];

const K8DaemonsetConfig = () => [
  {
    title: i18n.global.t('k8.daemonset'),
    titleWithCount: i18n.global.t('k8.allDaemonsets'),
    routeName: 'daemonsets',
    showSearch: true,
    displayTotal: true,
    disableTitle: false,
    disableViewBtn: true,
    searchPlaceholder: i18n.global.t('k8.daemonsetPlace'),
    headerKeys: OverviewHeaderKeys['daemonset'](),
    instanceType: InstanceType['daemonsets'],
    defaultSortKey: K8HeaderKeys.daemonTotalPods,
  },
];

const K8PodConfig = () => [
  {
    title: i18n.global.t('k8.pod'),
    titleWithCount: i18n.global.t('k8.allPods'),
    routeName: 'pods',
    showSearch: true,
    displayTotal: true,
    disableTitle: false,
    disableViewBtn: true,
    searchPlaceholder: i18n.global.t('k8.podsPlace'),
    headerKeys: headerKeys['pod'](),
    instanceType: InstanceType['pods'],
    defaultSortKey: K8HeaderKeys.podCPUusage,
  },
];

const configTableMap = {
  k8mNamespacesTable: K8NamespaceConfig,
  k8mDeployementsTable: K8DeploymentConfig,
  k8mDaemonsetsTable: K8DaemonsetConfig,
  k8mStatefulsetsTable: K8StatefulsetConfig,
  k8mPodsTable: K8PodConfig,
};

const SortKeyMap = Object.freeze({
  NEWEST: 'NEWEST',
  OLDEST: 'OLDEST',
  noOfCrashes: 'crashes',
  noOfRequests: 'noOfRequests',
});

const ToggleData = [i18n.global.t('k8.tableView'), i18n.global.t('k8.mapView')];

export {
  SortKeyMap,
  K8HeaderKeys,
  K8ClusterTablesConfig,
  ToggleData,
  K8NodeOverviewConfig,
  K8NamespaceConfig,
  K8PodConfig,
  K8DaemonsetConfig,
  K8StatefulsetConfig,
  K8DeploymentConfig,
  configTableMap,
};
